/**
 * V3-Aligned Processing Status Messages
 * 
 * All messages must be:
 * - Factually correct
 * - Map to real V3 pipeline stages
 * - No raw numbers, sensors, or biomechanics claims
 * - No exact measurements
 * - No mobility testing implications
 * - No real-time correction claims
 * - Technically confident, slightly playful but restrained tone
 */

export const PROCESSING_MESSAGES = {
  early: [
    "Securing video input",
    "Preparing swing frames",
    "Stabilizing camera perspective",
  ],
  analysis: [
    "Analyzing swing movement patterns",
    "Reviewing rotational sequencing",
    "Assessing balance and motion control",
    "Evaluating swing compensations",
    "Normalizing analysis results",
  ],
  interpretation: [
    "Identifying primary swing patterns",
    "Mapping movement to performance outcomes",
    "Applying scoring model",
    "Generating coaching explanations",
    "Preparing your analysis",
  ],
} as const;

export type ProcessingStage = keyof typeof PROCESSING_MESSAGES;


